// extracted by mini-css-extract-plugin
module.exports = {"color-salmon":"#F5B9A1","colorSalmon":"#F5B9A1","promoArea":"_1YuSg _1Zmlx","promoIcon":"_7ONc7","promoText":"_1raPf _1R_Wx _2h12O","promoTCsIcon":"_2VkR2","promoTCs":"_1qDxf"};